"use strict";
import {http} from '../../core';
import Config from "../../app.config";
const RequestService = http.create();
const BASE_API = Config.BASE_API;
const RequestbaseURL = http.create({baseURL:Config.BASEURL});
export default {
    // 变更事件列表
    getList: function (params) {
        return RequestService.get("change/list", params);
    },
    // 新增变更
    addChange: function (params) {
          return RequestService.post('change/add',params);
    },
    // 修改事件
    updateChange: function (params) {
          return RequestService.post('change/update',params);
    },
    // 变更详情
    detail: function (params) {
        return RequestService.get("change/detail", params);

    },
    // 变更删除
    deteleChange:function (params) {
        return RequestService.post("change/delete",params);
    },
    // 繁忙度统计---组繁忙度
    busynessGroup:function (departmentId) {
        return RequestService.get("organization/group/busyness",{ departmentId:departmentId })
    },
    // 繁忙度统计---人员繁忙度
    busynessUser:function (userId) {
        return RequestbaseURL.get("itsm/v2/organization/user/busyness",{ internalUserid:userId })
    },
    //新增时获取事件模板
    getChaTemplateList(params){
        return RequestService.get('case/template/list',params)
    },
    //选择模板后请求模板详情
    getChaTemplate(params){
        return RequestService.get('case/template/describe',{id:params})
    },
    // 根据关键字获取知识列表
    getKnowledgeList:function (params) {
        return RequestService.get("knowledge/query",params);
    },
    // 获取报告人列表
    getReporterList: function (params) {
        return Promise.resolve({
            list: [
                {id: 1},
                {id: 2},
                {id: 3}
            ],
            total: 20
        })
    },

}


